<p mat-dialog-title>
  {{ modalData.text }}
  <ng-container *ngIf="modalData.fullName && modalData.name === 'reopen'">{{ modalData.fullName }}</ng-container>
  <ng-container *ngIf="modalData.hasDate">
    <br />
    for {{ timesheetDate$ | async | date : 'MMMM yyyy' }}?
  </ng-container>
  <ng-container *ngIf="modalData.hasSelectedMonth && modalData.name === customDeadlineModal">
    <br />
    for {{ selectedCustomDeadlineMonth$ | async | date : 'MMMM yyyy' }}?
  </ng-container>
  <ng-container *ngIf="modalData.hasSelectedMonth && modalData.name === customNotificationsModal">
    <br />
    for {{ selectedCustomNotificationsMonth$ | async | date : 'MMMM yyyy' }}?
  </ng-container>
  <ng-container *ngIf="modalData.fullName && modalData.userStatus">
    {{ modalData.fullName }} to {{ modalData.userStatus }}?
  </ng-container>
  <ng-container *ngIf="modalData.details">
    {{ modalData.details }}
  </ng-container>
</p>

<div mat-dialog-actions>
  <app-button class="modal-button" [text]="approveText" [color]="primaryColor" (OnClick)="modalAction()"></app-button>
  <app-button
    *ngIf="cancelText"
    class="modal-button"
    [text]="cancelText"
    [color]="warnColor"
    (OnClick)="closeModal()"
  ></app-button>
</div>
